// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2wInN","inner":"Footer_inner__2FWEU"};